let $ = jQuery;

let breakpoints = require('../utilities/breakpoints');
let _ = require('lodash');

import ScrollMagic from 'scrollmagic';
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

class AnimationManager {

  constructor(name, submit, wrapper) {
    this.controller = new ScrollMagic.Controller();

    this.debouncedResize = _.debounce(function() {
      this.handleState();
    }, 400);

    $(window).on('resize', () => {
      this.debouncedResize();
    }).trigger('resize');
  }

  handleState() {
    if(
      breakpoints.current === 'large' ||
      breakpoints.current === 'xlarge'
    ) {
      this.destroyScenes();
      this.createScenes();
      $('html').addClass('js-animate');
    } else {
      this.destroyScenes();
      $('html').removeClass('js-animate');
    }
  }

  createScenes() { }

  destroyScenes() {
    this.controller.destroy(true);
    this.controller = new ScrollMagic.Controller();
  }

}

module.exports = AnimationManager;
